import { render, staticRenderFns } from "./TopAlert.vue?vue&type=template&id=6d554a3e&"
import script from "./TopAlert.vue?vue&type=script&lang=js&"
export * from "./TopAlert.vue?vue&type=script&lang=js&"
import style0 from "./TopAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports